/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import { defineMessage } from 'react-intl'

// Global app defaults
export const DEFAULT_LOCALE = 'de-DE'
export const DEFAULT_SITE_TITLE = 'Avoury. The Tea'
export const MAX_CACHE_AGE = 60 * 15 // 15 min
export const MAX_PAGE_CACHE_AGE = 60 * 60 // 60 min

// Constants used in the used for product searching.
export const DEFAULT_SEARCH_PARAMS = {
  limit: 25,
  offset: 0,
  sort: 'best-matches',
  refine: []
}
export const DEFAULT_LIMIT_VALUES = [25, 50, 100] // Page sizes

// Constants for Search Component
export const RECENT_SEARCH_LIMIT = 5
export const RECENT_SEARCH_KEY = 'recent-search-key'
export const RECENT_SEARCH_MIN_LENGTH = 3

// Constants for the Homepage's Shop Products section.
export const HOME_SHOP_PRODUCTS_CATEGORY_ID = 'newarrivals'
export const HOME_SHOP_PRODUCTS_LIMIT = 10

// Constants for menu
export const CAT_MENU_DEFAULT_NAV_DEPTH = 1
export const CAT_MENU_DEFAULT_ROOT_CATEGORY = 'root'
export const CAT_MENU_STALE_TIME = 10000 // 10 seconds

export const cssColorGroups = {
  beige: '#d3bca9',
  black: '#000000',
  blue: '#4089c0',
  brown: '#8e6950',
  green: '#88c290',
  grey: '#919191',
  gray: '#919191',
  silver: '#c0c0c0',
  navy: '#000080',
  orange: '#f4995c',
  pink: '#f5a0ca',
  purple: '#9873b9',
  red: '#df5b5b',
  white: '#FFFFFFF',
  yellow: '#fbe85a',
  gold: '#ffd700',
  miscellaneous:
    'linear-gradient(to right, orange , yellow, green, cyan, blue, violet)'
}

// Color to use for the UI surrounding the page in browsers.
export const THEME_COLOR = '#0176D3'

export const FILTER_ACCORDION_SATE = 'filters-expanded-index'

export const HOME_HREF = '/'

export const MAX_ORDER_QUANTITY = 10

export const urlPartPositions = {
  PATH: 'path',
  QUERY_PARAM: 'query_param',
  NONE: 'none'
}

// Toast messages exist outside the scope of the base IntlProvider. This means
// that commonly used components that require localization cannot easily be
// extracted into a hook/helper. However, we can still extract the message
// definitions to a common location (here), so that each message is only defined
// once.

export const TOAST_MESSAGE_ADDED_TO_WISHLIST = defineMessage({
  id: 'global.info.added_to_wishlist',
  defaultMessage:
    '{quantity} {quantity, plural, one {item} other {items}} added to wishlist'
})

export const TOAST_ACTION_VIEW_WISHLIST = defineMessage({
  defaultMessage: 'View',
  id: 'global.link.added_to_wishlist.view_wishlist'
})

export const TOAST_MESSAGE_REMOVED_FROM_WISHLIST = defineMessage({
  id: 'global.info.removed_from_wishlist',
  defaultMessage: 'Item removed from wishlist'
})

//@todo: Move these settings to SFCC backend (with general App state)
export const SERVICE_CLOUD_CONTACT_FORM_KEYS = {
  STAGING_KEY: '00D0E0000002O8f',
  PRODUCTION_KEY: '00D1t000000tl1f'
}
export const SERVICE_CLOUD_CONTACT_FORM_URLS = {
  STAGING_URL:
    'https://msp-portal--stage.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8',
  PRODUCTION_URL:
    'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8'
}

export const EXPRESS_SHIPPING_METHOD_ID = 'dhlExpress'

export const AGENT_COOKIE_NAME = 'MSP_POS_AGENT'

export const REFINIMENT_AMOUNT_ATTRIBUTES = [
  'c_flavorIntensity',
  'c_fruitiness',
  'c_roasting'
]

export const REFINIMENT_CAFFEINE_ATTRIBUTES = ['c_caffeine']
export const MAX_IMAGES_TO_DISPLAY = 4

export const MIN_AMOUNT_FREE_SHIPPING = 70
export const MIN_BOXES_FREE_DELIVERY = 12
export const MIN_BOXES_ORDER = 6

export const STANDING_ORDER_PRODUCT_CATEGORY = 'tea'
